export default {
  env: 'test',
  login: {
    url: 'https://security-provider-login-dev-login-api.apps.ocp.ar.bsch/login',
    jwt: 'authorization',
  },
  api: {
    url: 'https://api.di-dev.prismamp.com/backoffice-bff/prepaidcard',
    jwt: 'authorization',
  },
};
